import { render, staticRenderFns } from "./briefe.vue?vue&type=template&id=7d67fa42&scoped=true&"
import script from "./briefe.vue?vue&type=script&lang=js&"
export * from "./briefe.vue?vue&type=script&lang=js&"
import style0 from "./briefe.vue?vue&type=style&index=0&id=7d67fa42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d67fa42",
  null
  
)

export default component.exports